<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >

            <rkm-row class="flex-nowrap">
                <rkm-col cols="2">
                    <rkm-form-input
                        label="Código"
                        v-model="model.codigo"
                        :validations="validations.codigo"

                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-input
                        label="Descrição"
                        v-model="model.descricao"
                        :validations="validations.descricao"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-0 text-nowrap">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click.stop="$refs.Form.validate(add)"
                    >
                        Incluir
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        color="secondary"
                        @click.stop="resetForm"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <List
            v-if="!hasIndex"
            ref="List"
            :data="data"
            @handleAlter="handleAlter"
        />
    </div>
</template>

<script>

// Components.
import List from './List'

// Mixins.
import { repository, stringCase, object, error, } from '@/mixins'

export default {
    components: {
        List,
    },
    computed: {
        maskValor(){

            var mascara = '##,##'

            if (this.data.model.laboratorio.valor && this.data.model.laboratorio.valor.length < 6){
                mascara = '##,##'
            }
            else if (this.data.model.laboratorio.valor && this.data.model.laboratorio.valor.length < 7){
                mascara = '###,##'
            }
            else if (this.data.model.laboratorio.valor && this.data.model.laboratorio.valor.length < 9){
                mascara = '#.###,##'
            }

            return mascara
        },
        validations() {
            return {
                codigo: {
                    required: true,
                    min: 3,
                    max: 8,
                },
                descricao: {
                    required: true,
                    min: 3,
                    max: 150,
                },
            }
        },
        hasIndex() {

            return this.index !== null
        },
    },
    data: () => ({
        model: {
            id: null,
            descricao: '',
            codigo: '',
        },
        index: null,
    }),
    mixins: [ repository, stringCase, object, error ],
    props: {
        data: { type: Object, required: true },
    },
    methods: {
        add() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    const texto = this.clone(this.model)

                    if (this.hasIndex) {

                        const objId = this.data.model.textoPronto.findIndex((obj => obj.id == this.model.id));

                        this.$set(this.data.model.textoPronto, objId, texto)
                    } else {

                        texto.id = this.uniqueId('texto' + new Date().getTime())

                        this.data.model.textoPronto.push(texto)
                    }

                    this.resetForm()
            })
        },
        validate() {
            return this.$refs.Form.validate()
        },
        resetForm() {

            this.index = null

            this.model.id = null
            this.model.descricao = ''
            this.model.codigo = ''

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleAlter(index, item) {

            this.index = index
            this.model.id = item.id
            this.model.descricao = item.descricao
            this.model.codigo = item.codigo
        }
    },
}
</script>